/** Request bounds for `POST /search/rank` and `POST /search/ask`. The caller is the command palette,
 *  whose index is a few hundred SHORT interface strings — these caps sit comfortably above that while
 *  keeping one request's embedding work (and one prompt) bounded no matter what a client sends.
 *  web/lib/searchBounds.ts is a byte-identical browser copy, pinned by tests/contract/webMirrorContracts.test.ts. */
export const SEARCH_MAX_CANDIDATES = 400;
export const SEARCH_MAX_TEXT_CHARS = 200;
export const SEARCH_MAX_QUERY_CHARS = 200;
